


// import React, { useState, useEffect } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// const API_BASE_URL = "https://backend.maamaas.com/subscription";
// const API_KEY = 'your_api_key_here';

// const ALL_POSSIBLE_MODULES = [
//     "Home", "Company", "Settings_Controls", "Account_History", "Order_Management",
//     "Menu_Management",
//     "Promotions_Discounts", "Report_Analysis"
// ].sort();

// const DEFAULT_DURATIONS = [90, 180, 365];

// const Cateringsubscriptiondata = () => {
//     const [planModuleConfig, setPlanModuleConfig] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [editingPlanName, setEditingPlanName] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     // ✅ Fetch plans
//     useEffect(() => {
//         const fetchPlans = async () => {
//             try {
//                 showLoader();
//                 setLoading(true);
//                 const token = localStorage.getItem("authToken");
//                 if (!token) throw new Error("No auth token found!");

//                 const response = await fetch(`${API_BASE_URL}/api/get/vertical/CATERINGS_SERVICES`, {
//                     headers: {
//                         "X-API-Key": API_KEY,
//                         "Accept": "application/json",
//                         "Authorization": `Bearer ${token}`
//                     }
//                 });

//                 if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
//                 const data = await response.json();

//                 const planName = "VISIBILITY_LEAD";
//                 const filteredPlans = data.filter(
//                     p => p.planType === planName &&
//                         p.businessVerticals === "CATERINGS_SERVICES" &&
//                         DEFAULT_DURATIONS.includes(p.days)
//                 );

//                 const config = {
//                     [planName]: DEFAULT_DURATIONS.map(d => {
//                         const existing = filteredPlans.find(p => p.days === d);
//                         return existing || {
//                             id: `${planName}-${d}`,
//                             days: d,
//                             price: 0,
//                             businessModules: [],
//                             description: ""
//                         };
//                     })
//                 };

//                 setPlanModuleConfig(config);
//             } catch (err) {
//                 console.error("❌ Fetch plans failed:", err);
//                 setError(err.message);
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchPlans();
//     }, []);

//     // ✅ Helpers to update local state
//     const handlePriceChange = (planId, newPrice) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             Object.keys(updated).forEach(planName => {
//                 updated[planName] = updated[planName].map(p =>
//                     p.id === planId ? { ...p, price: Number(newPrice) } : p
//                 );
//             });
//             return updated;
//         });
//     };

//     const handleModuleChange = (planId, moduleName, isChecked) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             Object.keys(updated).forEach(planName => {
//                 updated[planName] = updated[planName].map(p => {
//                     if (p.id === planId) {
//                         const modules = p.businessModules || [];
//                         return {
//                             ...p,
//                             businessModules: isChecked ? [...modules, moduleName] : modules.filter(m => m !== moduleName)
//                         };
//                     }
//                     return p;
//                 });
//             });
//             return updated;
//         });
//     };

//     const handleDescriptionChange = (planId, newDescription) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             Object.keys(updated).forEach(planName => {
//                 updated[planName] = updated[planName].map(p =>
//                     p.id === planId ? { ...p, description: newDescription } : p
//                 );
//             });
//             return updated;
//         });
//     };

//     const handleDurationChange = (planName, index, newValue) => {
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planName][index] = { ...updated[planName][index], days: Number(newValue) };
//             return updated;
//         });
//     };

//     const handleStartEdit = planName => setEditingPlanName(planName);
//     const handleStopEdit = () => setEditingPlanName(null);

//     // ✅ Save plans
//     const handleSavePlans = async (planName) => {
//         const plans = planModuleConfig[planName] || [];
//         const savedPlans = [];
//         const token = localStorage.getItem("authToken");

//         for (let plan of plans) {
//             const payload = {
//                 price: Number(plan.price) || 0,
//                 businessModules: plan.businessModules || [],
//                 description: plan.description || "",
//                 planType: planName,
//                 businessVerticals: "CATERINGS_SERVICES",
//                 days: plan.days,
//             };

//             try {
//                 const headers = {
//                     "Content-Type": "application/json",
//                     "X-API-Key": API_KEY,
//                     ...(token && { "Authorization": `Bearer ${token}` })
//                 };

//                 // ✅ Corrected condition: new = no ID → POST (add), existing = has ID → PUT (update)
//                 const isNew = !plan.id || plan.id.toString().includes("-");

//                 const response = await fetch(
//                     isNew
//                         ? `https://backend.maamaas.com/subscription/api/admin/plans/add` // POST for new plan
//                         : `https://backend.maamaas.com/subscription/api/admin/plans/update/${plan.id}`, // PUT for update
//                     {
//                         method: isNew ? "POST" : "PUT",
//                         headers,
//                         body: JSON.stringify(payload),
//                     }
//                 );

//                 if (!response.ok) {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed saving plan ${plan.days} days`);
//                 }

//                 const savedPlan = await response.json();
//                 savedPlans.push(savedPlan);

//             } catch (err) {
//                 console.error(err);
//                 alert(`Error saving plan ${plan.days} days: ${err.message}`);
//             }
//         }

//         // ✅ Update state with saved plans
//         setPlanModuleConfig(prev => {
//             const updated = { ...prev };
//             updated[planName] = updated[planName].map(p => {
//                 const saved = savedPlans.find(sp => sp.days === p.days);
//                 return saved ? saved : p;
//             });
//             return updated;
//         });

//         handleStopEdit();
//         alert("All plans saved successfully!");
//     };


//     if (loading) return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
//     if (error) return <div className="d-flex justify-content-center align-items-center vh-100 text-danger">Error: {error}</div>;

//     return (
//         <div className="container-fluid" style={{ paddingTop: "140px", paddingBottom: "20px", height: '100vh' }}>
//             <div className="row justify-content-center">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-8">
//                     {["VISIBILITY_LEAD"].map(planName => {
//                         const plans = planModuleConfig[planName] || [];
//                         const isEditing = editingPlanName === planName;

//                         return (
//                             <div className="col-lg-12 mb-5" key={planName}>
//                                 <h4 className="mb-3 text-center">{planName} PLAN</h4>
//                                 <div className="table-responsive">
//                                     <table className="table table-bordered text-center align-middle">
//                                         <thead>
//                                             <tr style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
//                                                 <th style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>Modules / Days</th>
//                                                 {plans.map((plan, index) => (
//                                                     <th key={plan.id} style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
//                                                         <input
//                                                             type="number"
//                                                             value={plan.days || 0}
//                                                             onChange={(e) => handleDurationChange(planName, index, e.target.value)}
//                                                             disabled={!isEditing}
//                                                             style={{ width: "80px", textAlign: "center" }}
//                                                         />
//                                                     </th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td><strong>Price (₹)</strong></td>
//                                                 {plans.map(plan => (
//                                                     <td key={plan.id}>
//                                                         <input
//                                                             type="number"
//                                                             value={plan.price || 0}
//                                                             onChange={(e) => handlePriceChange(plan.id, e.target.value)}
//                                                             readOnly={!isEditing}
//                                                             style={{
//                                                                 width: "100px",
//                                                                 textAlign: "center",
//                                                                 backgroundColor: isEditing ? "#fff" : "#f8f9fa"
//                                                             }}
//                                                         />
//                                                     </td>
//                                                 ))}
//                                             </tr>

//                                             {ALL_POSSIBLE_MODULES.map(moduleName => (
//                                                 <tr key={moduleName}>
//                                                     <td className="text-start">{moduleName.replace(/_/g, " ")}</td>
//                                                     {plans.map(plan => (
//                                                         <td key={plan.id}>
//                                                             <input
//                                                                 type="checkbox"
//                                                                 checked={(plan.businessModules || []).includes(moduleName)}
//                                                                 onChange={(e) => handleModuleChange(plan.id, moduleName, e.target.checked)}
//                                                                 disabled={!isEditing}
//                                                             />
//                                                         </td>
//                                                     ))}
//                                                 </tr>
//                                             ))}

//                                             <tr>
//                                                 <td><strong>Description</strong></td>
//                                                 <td colSpan={plans.length}>
//                                                     <textarea
//                                                         value={plans[0]?.description || ""}
//                                                         onChange={(e) => handleDescriptionChange(plans[0].id, e.target.value)}
//                                                         readOnly={!isEditing}
//                                                         style={{
//                                                             width: "100%",
//                                                             height: "100px",
//                                                             backgroundColor: isEditing ? "#fff" : "#f8f9fa",
//                                                             padding: "8px",
//                                                             resize: "vertical"
//                                                         }}
//                                                     />
//                                                 </td>
//                                             </tr>

//                                             <tr>
//                                                 <td colSpan={plans.length + 1} className="text-center">
//                                                     {isEditing ? (
//                                                         <button className="btn btn-primary" onClick={() => handleSavePlans(planName)}>Save Plans</button>
//                                                     ) : (
//                                                         <button className="btn btn-warning" onClick={() => handleStartEdit(planName)}>Update Plans</button>
//                                                     )}
//                                                 </td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>
//                 <div className="col-lg-2"></div>
//             </div>
//         </div>
//     );
// };

// export default Cateringsubscriptiondata;


















import React, { useState, useEffect } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
const API_BASE_URL = "https://backend.maamaas.com/subscription";
const API_KEY = 'your_api_key_here';

// Module name mapping
const MODULE_NAME_MAP = {
    // Old names -> New names for display
    "Home": "Dashboard",
    "Company": "Business_Profile",
    "Settings_Controls": "Settings_Controls",
    "Menu_Management": "Services_Products",
    "Order_Management": "Order_Management", // Will be split into 3
    "Promotions_Discounts": "Promotions",
    "Account_History": "Account_History",
    "Report_Analysis": "Report_Analysis"
};

// All possible modules with new names
const ALL_POSSIBLE_MODULES = [
    "Dashboard",
    "Business_Profile",
    "Settings_Controls",
    "Services_Products",
    "Lead_Orders",
    "Confirmed_Orders",
    "Packages_Order",
    "Account_History",
    "Report_Analysis",
    "Promotions"
].sort();

const DEFAULT_DURATIONS = [90, 180, 365];

const Cateringsubscriptiondata = () => {
    const [planModuleConfig, setPlanModuleConfig] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingPlanName, setEditingPlanName] = useState(null);
    const { showLoader, hideLoader } = useLoader();

    // Convert old module names to new names for display
    const convertToNewModuleNames = (modules) => {
        if (!Array.isArray(modules)) return [];

        const newModules = [];
        modules.forEach(module => {
            const mappedModule = MODULE_NAME_MAP[module] || module;
            // Split Order_Management into three separate modules
            if (mappedModule === "Order_Management") {
                newModules.push("Lead_Orders", "Confirmed_Orders", "Packages_Order");
            } else if (mappedModule && !newModules.includes(mappedModule)) {
                newModules.push(mappedModule);
            }
        });
        return newModules;
    };

    // Convert new module names back to old names for saving to backend
    const convertToOldModuleNames = (modules) => {
        if (!Array.isArray(modules)) return [];

        const reverseMap = {};
        Object.entries(MODULE_NAME_MAP).forEach(([oldName, newName]) => {
            reverseMap[newName] = oldName;
        });

        const oldModules = [];
        const hasLeadOrder = modules.includes("Lead_Orders");
        const hasConfirmedOrder = modules.includes("Confirmed_Orders");
        const hasPackagesOrder = modules.includes("Packages_Order");

        // If any of the three order types are selected, add Order_Management
        if (hasLeadOrder || hasConfirmedOrder || hasPackagesOrder) {
            oldModules.push("Order_Management");
        }

        // Add other modules
        modules.forEach(module => {
            if (!["Lead_Orders", "Confirmed_Orders", "Packages_Order"].includes(module)) {
                const oldName = reverseMap[module] || module;
                if (oldName && !oldModules.includes(oldName)) {
                    oldModules.push(oldName);
                }
            }
        });

        return oldModules;
    };

    // ✅ Fetch plans
    useEffect(() => {
        const fetchPlans = async () => {
            try {
                showLoader();
                setLoading(true);
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("No auth token found!");

                const response = await fetch(`${API_BASE_URL}/api/get/vertical/CATERINGS_SERVICES`, {
                    headers: {
                        "X-API-Key": API_KEY,
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });

                if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
                const data = await response.json();

                const planName = "VISIBILITY_LEAD";
                const filteredPlans = data.filter(
                    p => p.planType === planName &&
                        p.businessVerticals === "CATERINGS_SERVICES" &&
                        DEFAULT_DURATIONS.includes(p.days)
                );

                const config = {
                    [planName]: DEFAULT_DURATIONS.map(d => {
                        const existing = filteredPlans.find(p => p.days === d);
                        const businessModules = existing ?
                            convertToNewModuleNames(Array.isArray(existing.businessModules) ? existing.businessModules : []) :
                            [];

                        return existing ? {
                            ...existing,
                            businessModules: businessModules
                        } : {
                            id: `${planName}-${d}`,
                            days: d,
                            price: 0,
                            businessModules: [],
                            description: ""
                        };
                    })
                };

                setPlanModuleConfig(config);
            } catch (err) {
                console.error("❌ Fetch plans failed:", err);
                setError(err.message);
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchPlans();
    }, []);

    // ✅ Helpers to update local state
    const handlePriceChange = (planId, newPrice) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            Object.keys(updated).forEach(planName => {
                updated[planName] = updated[planName].map(p =>
                    p.id === planId ? { ...p, price: Number(newPrice) } : p
                );
            });
            return updated;
        });
    };

    const handleModuleChange = (planId, moduleName, isChecked) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            Object.keys(updated).forEach(planName => {
                updated[planName] = updated[planName].map(p => {
                    if (p.id === planId) {
                        const modules = p.businessModules || [];
                        return {
                            ...p,
                            businessModules: isChecked ?
                                [...new Set([...modules, moduleName])] :
                                modules.filter(m => m !== moduleName)
                        };
                    }
                    return p;
                });
            });
            return updated;
        });
    };

    const handleDescriptionChange = (planId, newDescription) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            Object.keys(updated).forEach(planName => {
                updated[planName] = updated[planName].map(p =>
                    p.id === planId ? { ...p, description: newDescription } : p
                );
            });
            return updated;
        });
    };

    const handleDurationChange = (planName, index, newValue) => {
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planName][index] = { ...updated[planName][index], days: Number(newValue) };
            return updated;
        });
    };

    const handleStartEdit = planName => setEditingPlanName(planName);
    const handleStopEdit = () => setEditingPlanName(null);

    // ✅ Save plans
    const handleSavePlans = async (planName) => {
        const plans = planModuleConfig[planName] || [];
        const savedPlans = [];
        const token = localStorage.getItem("authToken");

        for (let plan of plans) {
            // Convert new module names back to old names for backend
            const oldModules = convertToOldModuleNames(plan.businessModules || []);

            const payload = {
                price: Number(plan.price) || 0,
                businessModules: oldModules,
                description: plan.description || "",
                planType: planName,
                businessVerticals: "CATERINGS_SERVICES",
                days: plan.days,
            };

            try {
                const headers = {
                    "Content-Type": "application/json",
                    "X-API-Key": API_KEY,
                    ...(token && { "Authorization": `Bearer ${token}` })
                };

                // ✅ Corrected condition: new = no ID → POST (add), existing = has ID → PUT (update)
                const isNew = !plan.id || plan.id.toString().includes("-");

                const response = await fetch(
                    isNew
                        ? `https://backend.maamaas.com/subscription/api/admin/plans/add` // POST for new plan
                        : `https://backend.maamaas.com/subscription/api/admin/plans/update/${plan.id}`, // PUT for update
                    {
                        method: isNew ? "POST" : "PUT",
                        headers,
                        body: JSON.stringify(payload),
                    }
                );

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || `Failed saving plan ${plan.days} days`);
                }

                const savedPlan = await response.json();
                // Convert saved plan's modules to new names
                savedPlan.businessModules = convertToNewModuleNames(savedPlan.businessModules || []);
                savedPlans.push(savedPlan);

            } catch (err) {
                console.error(err);
                alert(`Error saving plan ${plan.days} days: ${err.message}`);
            }
        }

        // ✅ Update state with saved plans
        setPlanModuleConfig(prev => {
            const updated = { ...prev };
            updated[planName] = updated[planName].map(p => {
                const saved = savedPlans.find(sp => sp.days === p.days);
                return saved ? saved : p;
            });
            return updated;
        });

        handleStopEdit();
        alert("All plans saved successfully!");
    };

    // Function to format module names for display
    const formatModuleName = (moduleName) => {
        const nameMap = {
            "Dashboard": "Dashboard",
            "Business_Profile": "Business Profile",
            "Settings_Controls": "Settings & Controls",
            "Services_Products": "Services & Products",
            "Lead_Orders": "Lead Orders",
            "Confirmed_Orders": "Confirmed Orders",
            "Packages_Order": "Packages Order",
            "Account_History": "Account & History",
            "Report_Analysis": "Report & Analysis",
            "Promotions": "Promotions"
        };

        return nameMap[moduleName] || moduleName.replace(/_/g, " ");
    };

    // Order modules as requested
    const orderedModules = [
        "Dashboard",
        "Business_Profile",
        "Settings_Controls",
        "Services_Products",
        "Lead_Orders",
        "Confirmed_Orders",
        "Packages_Order",
        "Account_History",
        "Report_Analysis",
        "Promotions"
    ];

    if (loading) return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
    if (error) return <div className="d-flex justify-content-center align-items-center vh-100 text-danger">Error: {error}</div>;

    return (
        <div className="container-fluid" style={{ paddingTop: "140px", paddingBottom: "20px", height: '100vh' }}>
            <div className="row justify-content-center">
                <div className="col-lg-2"></div>
                <div className="col-lg-8">
                    {["VISIBILITY_LEAD"].map(planName => {
                        const plans = planModuleConfig[planName] || [];
                        const isEditing = editingPlanName === planName;

                        return (
                            <div className="col-lg-12 mb-5" key={planName}>
                                <h4 className="mb-3 text-center">{planName} PLAN</h4>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center align-middle">
                                        <thead>
                                            <tr style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
                                                <th style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>Modules / Days</th>
                                                {plans.map((plan, index) => (
                                                    <th key={plan.id} style={{ backgroundColor: "rgb(160, 85, 176)", color: "#fff" }}>
                                                        <input
                                                            type="number"
                                                            value={plan.days || 0}
                                                            onChange={(e) => handleDurationChange(planName, index, e.target.value)}
                                                            disabled={!isEditing}
                                                            style={{ width: "80px", textAlign: "center" }}
                                                        />
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><strong>Price (₹)</strong></td>
                                                {plans.map(plan => (
                                                    <td key={plan.id}>
                                                        <input
                                                            type="number"
                                                            value={plan.price || 0}
                                                            onChange={(e) => handlePriceChange(plan.id, e.target.value)}
                                                            readOnly={!isEditing}
                                                            style={{
                                                                width: "100px",
                                                                textAlign: "center",
                                                                backgroundColor: isEditing ? "#fff" : "#f8f9fa"
                                                            }}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>

                                            {orderedModules.map(moduleName => (
                                                <tr key={moduleName}>
                                                    <td className="text-start">{formatModuleName(moduleName)}</td>
                                                    {plans.map(plan => (
                                                        <td key={plan.id}>
                                                            <input
                                                                type="checkbox"
                                                                checked={(plan.businessModules || []).includes(moduleName)}
                                                                onChange={(e) => handleModuleChange(plan.id, moduleName, e.target.checked)}
                                                                disabled={!isEditing}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}

                                            <tr>
                                                <td><strong>Description</strong></td>
                                                <td colSpan={plans.length}>
                                                    <textarea
                                                        value={plans[0]?.description || ""}
                                                        onChange={(e) => handleDescriptionChange(plans[0].id, e.target.value)}
                                                        readOnly={!isEditing}
                                                        style={{
                                                            width: "100%",
                                                            height: "100px",
                                                            backgroundColor: isEditing ? "#fff" : "#f8f9fa",
                                                            padding: "8px",
                                                            resize: "vertical"
                                                        }}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan={plans.length + 1} className="text-center">
                                                    {isEditing ? (
                                                        <button className="btn btn-primary" onClick={() => handleSavePlans(planName)}>Save Plans</button>
                                                    ) : (
                                                        <button className="btn btn-warning" onClick={() => handleStartEdit(planName)}>Update Plans</button>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="col-lg-2"></div>
            </div>
        </div>
    );
};

export default Cateringsubscriptiondata;